import { Button, Modal, Label } from "flowbite-react";
import { useEffect, useState } from "react";
import Select from "react-select";
import { useGetAgentsQuery } from "@/api/agentApi/agent";
import { useTranslation } from "react-i18next";

interface AgentAssignmentDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (agentIds: number[]) => void;
}

export default function AgentAssignmentDialog({
  open,
  onClose,
  onSubmit,
}: AgentAssignmentDialogProps) {
  const { t } = useTranslation(["workShift", "common"]);
  const [selectedAgents, setSelectedAgents] = useState<{label: string, value: number}[]>([]);
  const [agentOptions, setAgentOptions] = useState<{ label: string; value: number }[]>([]);

  const { data: agentsData, isLoading } = useGetAgentsQuery({
      pagination: { pageSize: 100 }
  });

  useEffect(() => {
    if (agentsData) {
        const items = agentsData.items || agentsData.data || [];
        const options = items.map((agent: any) => ({
            label: agent.agent_username,
            value: agent.id || agent.agent_id,
        }));
        setAgentOptions(options);
    }
  }, [agentsData]);

  useEffect(() => {
      if (!open) {
          setSelectedAgents([]);
      }
  }, [open]);

  const handleSubmit = () => {
    const ids = selectedAgents.map(opt => opt.value);
    onSubmit(ids);
  };

  return (
    <Modal show={open} onClose={onClose}>
      <Modal.Header>{t("workShift:assignAgentsTitle")}</Modal.Header>
      <Modal.Body className="overflow-visible">
        <div className="space-y-4">
             <div className="mb-2 block">
                <Label value={t("workShift:selectAgents")} />
             </div>
             <Select
                isMulti
                options={agentOptions}
                value={selectedAgents}
                onChange={(selected) => setSelectedAgents(selected as any)}
                isLoading={isLoading}
                placeholder={t("workShift:searchAgentsPlaceholder")}
                className="basic-multi-select"
                classNamePrefix="select"
                menuPortalTarget={document.body} 
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
             />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button color="gray" onClick={onClose}>
          {t("common:cancel")}
        </Button>
        <Button onClick={handleSubmit}>
           {t("workShift:assign")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
